import popupConfirm from "../../assets/scripts/common/popupConfirm";
import {initBodyScroll, killBodyScroll} from "../../assets/scripts/common/overlayScrollbars";
import {slideDown, slideUp} from "@roghz/slidetoggle";
import {OverlayScrollbars} from "overlayscrollbars";

document.addEventListener("DOMContentLoaded", () => {

    const ajaxContainer = document.getElementById("ajax-resources");
    if (ajaxContainer) {
        const ajaxUrl = fintua.ajaxurl;
        const nonce = fintua.nonce;
        const filtersScroll = [];
        const isMobile = window.matchMedia("(max-width: 1023px)");
        let previousData = {};
        const urlParams = new URLSearchParams(window.location.search);
        const searchQuery = urlParams.get("search");

        if (searchQuery) {
            const searchInput = document.querySelector(".resources-search");
            searchInput.value = searchQuery;
        }

        document.addEventListener("keydown", (event) => {
            const searchInput = document.querySelector(".resources-search");
            if (event.target === searchInput && event.key === "Enter") {
                event.preventDefault();
                sendAjaxRequest(collectFilterData());
            }
        });

        document.addEventListener("submit", (event) => {
            const searchForm = document.querySelector(".resources-search")?.closest("form");
            if (event.target === searchForm) {
                event.preventDefault();
                sendAjaxRequest(collectFilterData());
            }
        });

        function sendAjaxRequest(data) {
            const loopList = document.querySelector(".loop-list");

            const hasFiltersChanged = Object.keys(data).some((key) => {
                if (key === "paged") {
                    return false;
                }
                const previousValue = previousData[key] || [];
                const currentValue = data[key] || [];
                return JSON.stringify(previousValue) !== JSON.stringify(currentValue);
            });

            if (hasFiltersChanged) {
                data.paged = "1";
            }

            previousData = Object.assign({}, data);
            delete previousData.paged;

            const formData = new FormData();
            formData.append("action", "reload_resources");
            formData.append("security", nonce);
            formData.append("config", JSON.stringify(resourcesConfig));

            Object.keys(data).forEach((key) => {
                if (Array.isArray(data[key])) {
                    data[key].forEach((value) => formData.append(`${key}[]`, value));
                } else {
                    formData.append(key, data[key]);
                }
            });

            ajaxContainer.classList.add("loading");
            loopList.classList.add("loading");

            fetch(ajaxUrl, {
                method: "POST",
                body: formData,
            })
                .then((response) => response.json())
                .then((response) => {
                    ajaxContainer.classList.remove("loading");
                    loopList.classList.remove("loading");
                    if (response.success) {
                        ajaxContainer.innerHTML = response.data.html;

                        window.history.pushState({}, "", buildURL(data));

                        updatePagination();
                        updateFilterOptions();

                        if (getCurrentPage() > 1) {
                            document.querySelector("body").classList.add("paged");
                        } else {
                            document.querySelector("body").classList.remove("paged");
                        }
                    } else {
                        console.error("Failed to load resources:", response.data.message);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching resources:", error);
                    popupConfirm("Error", "An unknown error has occurred. Please reload the page and try again.", "If the error persists, please contact customer service.", "Close", "").then(() => {
                    });
                    ajaxContainer.classList.remove("loading");
                });
        }

        function collectFilterData() {
            const searchValue = document.querySelector(".resources-search").value || "";
            const filterData = {
                search: searchValue,
                paged: getCurrentPage(),
            };

            const checkBoxNames = [...new Set(Array.from(document.querySelectorAll('input[type="checkbox"]')).map((checkBox) => checkBox.name))];

            checkBoxNames.forEach((checkBoxName) => {
                const nameWithoutBrackets = checkBoxName.slice(0, -2);
                filterData[nameWithoutBrackets] = gatherCheckedValues(`input[name="${checkBoxName}"]:checked`);
            });

            return filterData;
        }

        function gatherCheckedValues(selector) {
            return Array.from(document.querySelectorAll(selector)).map((input) => input.value);
        }

        function buildURL(data) {
            let baseUrl = window.location.origin + window.location.pathname;
            baseUrl = baseUrl.replace(/\/$/, "");
            baseUrl = baseUrl.replace(/\/page\/\d+\/?/, "");

            if (data.paged > 1) {
                baseUrl += `/page/${data.paged}/`;
            }

            const queryStringComponents = [];

            if (data.search) {
                queryStringComponents.push(`search=${encodeURIComponent(data.search)}`);
            }

            delete data.search;
            delete data.paged;

            for (const key in data) {
                if (Array.isArray(data[key]) && data[key].length) {
                    data[key].forEach((value) => {
                        queryStringComponents.push(`${key}[]=${value}`);
                    });
                }
            }

            const queryString = queryStringComponents.join("&");
            if (queryString) {
                baseUrl += `/?${queryString}`;
            }

            return baseUrl;
        }

        function scrollToSettings() {
            const settingsDiv = document.querySelector(".settings");
            if (settingsDiv) {
                const offsetTop = settingsDiv.getBoundingClientRect().top + window.scrollY - 150;
                window.scrollTo({
                    top: offsetTop,
                    behavior: "smooth",
                });
            }
        }

        function updatePagination() {
            document.querySelectorAll(".pagination a").forEach((link) => {
                link.addEventListener("click", (event) => {
                    event.preventDefault();
                    const url = new URL(event.target.href);
                    const paged = url.searchParams.get("paged") || extractPageNumberFromPath(url.pathname);

                    const filterData = collectFilterData();
                    filterData.paged = paged;
                    sendAjaxRequest(filterData);
                    scrollToSettings();
                });
            });
        }

        function extractPageNumberFromPath(pathname) {
            const match = pathname.match(/\/page\/(\d+)/);
            return match ? match[1] : "1";
        }

        function getCurrentPage() {
            const url = window.location.href;
            const urlParams = new URL(url);
            let page = urlParams.searchParams.get("paged");

            if (!page) {
                const pathParts = url.split("/");
                const pageIndex = pathParts.indexOf("page");
                if (pageIndex !== -1 && pageIndex + 1 < pathParts.length) {
                    page = pathParts[pageIndex + 1];
                } else {
                    page = "1";
                }
            }

            return page;
        }

        let lastMatch = null;
        const handleResize = () => {
            if (lastMatch !== isMobile.matches) {
                lastMatch = isMobile.matches;
                filtersScroll.forEach((scrollbar) => scrollbar.destroy());
            }
        };

        window.addEventListener("resize", handleResize);

        document.addEventListener("change", (event) => {
            if (!isMobile.matches) {
                if (event.target.matches('.settings.form input[type="checkbox"]')) {

                    sendAjaxRequest(collectFilterData());
                    updateFilterOptions();
                }
            }
        });

        document.addEventListener("click", async (e) => {
            const filtersWrapper = document.querySelector(".filters .wrapper");
            const options = filtersWrapper.querySelector(".options-list");
            const actions = filtersWrapper.querySelector(".actions");
            const footerSticky = document.querySelector(".footer-bar");

            if (e.target.matches(".settings .open-filters")) {
                e.preventDefault();
                if (isMobile.matches) {
                    filtersWrapper.classList.add("active");
                    footerSticky?.classList.add("hidden");
                    killBodyScroll();

                    const optionsList = document.querySelectorAll(".options");
                    optionsList.forEach((option) => {
                        option.style = "";
                    });

                    filtersScroll.push(
                        OverlayScrollbars(options, {
                            scrollbars: {autoHide: "never"},
                        })
                    );
                }
            }

            if (e.target.matches(".settings .close-filters")) {
                e.preventDefault();

                filtersWrapper.classList.remove("active");
                footerSticky?.classList.remove("hidden");
                initBodyScroll();

                filtersScroll.forEach((scrollbar) => scrollbar.destroy());
            }

            if (e.target.matches(".settings .apply")) {
                e.preventDefault();
                document.body.classList.remove("noscroll");
                options.classList.add("loading");
                actions.classList.add("loading");
                footerSticky?.classList.remove("hidden");

                initBodyScroll();

                sendAjaxRequest(collectFilterData());
                updateFilterOptions();
            }

            if (e.target.matches(".settings .clear")) {
                e.preventDefault();
                Array.from(document.querySelectorAll('.settings.form input[type="checkbox"]')).forEach((input) => {
                    input.checked = false;
                });
                document.querySelector(".resources-search").value = "";
                initBodyScroll();
                footerSticky?.classList.remove("hidden");
                updateFilterOptions();
                sendAjaxRequest(collectFilterData());
            }

            if (e.target.matches(".settings .set button")) {
                if (!isMobile.matches) {
                    e.preventDefault();
                    document.querySelectorAll(".settings .set button.active").forEach((button) => {
                        if (button !== e.target) {
                            button.classList.remove("active");
                            slideUp(button.nextElementSibling);
                        }
                    });

                    e.target.classList.toggle("active");

                    const isExpanded = e.target.classList.contains("active");
                    if (isExpanded) {
                        slideDown(e.target.nextElementSibling);
                    } else {
                        slideUp(e.target.nextElementSibling);
                    }
                }
            }

            const activeButton = document.querySelector(".settings .set button.active");
            if (activeButton && !activeButton.contains(e.target) && !activeButton.nextElementSibling.contains(e.target)) {
                activeButton.classList.remove("active");
                slideUp(activeButton.nextElementSibling);
            }

            if (e.target.matches(".current-filters .option")) {
                e.preventDefault();

                const checkbox = document.getElementById(e.target.dataset.for);

                if (checkbox) {
                    checkbox.click();

                    updateFilterOptions();
                    sendAjaxRequest(collectFilterData());
                }

                if (e.target.dataset.for === "search") {
                    const searchInput = document.querySelector(".resources-search");
                    if (searchInput) {
                        searchInput.value = "";

                        const url = new URL(window.location);
                        url.searchParams.delete("search");
                        window.history.pushState({}, "", url.toString());

                        toggleClearSearchActive();
                        updateFilterOptions();
                        sendAjaxRequest(collectFilterData());
                    }
                }
            }

            document.addEventListener("click", (event) => {
                if (event.target.matches(".clear-all")) {
                    event.preventDefault();

                    Array.from(document.querySelectorAll('.settings.form input[type="checkbox"]')).forEach((input) => {
                        input.checked = false;
                    });

                    document.querySelector(".resources-search").value = "";

                    document.querySelector(".alphabet-filtering .active")?.classList.remove("active");

                    const url = new URL(window.location);
                    url.searchParams.delete("search");
                    url.searchParams.delete("letter");
                    window.history.pushState({}, "", url.toString());

                    updateFilterOptions();
                    sendAjaxRequest(collectFilterData());
                }
            });

            if (e.target.matches(".clear-search")) {
                e.preventDefault();
                document.querySelector(".resources-search").value = "";
            }
        });

        const updateFilterOptions = () => {
            const filtersContainer = document.querySelector(".current-filters");
            const clearAll = document.querySelector(".clear-all");
            const searchInput = document.querySelector(".resources-search");

            if (!filtersContainer) {
                return;
            }

            const loopList = document.querySelector(".loop-list");

            filtersContainer.querySelectorAll(".option").forEach((option) => option.remove());

            const checkBoxNames = [...new Set(Array.from(document.querySelectorAll('input[type="checkbox"]')).map((checkBox) => checkBox.name))];

            let selectedOptions = [];
            checkBoxNames.forEach((checkBoxName) => {
                const checkedBoxes = Array.from(document.querySelectorAll(`input[name="${checkBoxName}"]:checked`));
                selectedOptions = [...selectedOptions, ...checkedBoxes];
            });

            if (searchInput && searchInput.value) {
                const searchButton = document.createElement("button");
                searchButton.className = "option";
                searchButton.textContent = `Search: ${searchInput.value}`;
                searchButton.dataset.for = "search";
                filtersContainer.appendChild(searchButton);
            }


            selectedOptions.forEach((option) => {
                const button = document.createElement("button");
                button.className = "option";
                button.textContent = option.nextElementSibling.textContent;
                button.dataset.for = option.id;
                filtersContainer.appendChild(button);
            });

            clearAll.style.display = selectedOptions.length || (searchInput && searchInput.value) ? "block" : "none";


            const currentPage = parseInt(getCurrentPage());
            const hasFilters = selectedOptions.length > 0 || (searchInput && searchInput.value) || currentPage > 1;

            if (hasFilters) {
                document.querySelector("body").classList.add("filtered");
            } else {
                document.querySelector("body").classList.remove("filtered");
            }
        };

        const toggleClearSearchActive = () => {
            const searchInput = document.querySelector(".resources-search");
            const clearSearchButton = document.querySelector(".clear-search");
            if (searchInput && clearSearchButton) {
                if (searchInput.value) {
                    clearSearchButton.classList.add("active");
                } else {
                    clearSearchButton.classList.remove("active");
                }
            }
        };

        updateFilterOptions();
        updatePagination();
        toggleClearSearchActive();

        document.addEventListener("input", (event) => {
            if (event.target.matches(".resources-search")) {
                toggleClearSearchActive();
            }
        });

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === "childList" && mutation.addedNodes.length) {
                    toggleClearSearchActive();
                }
            });
        });

        observer.observe(document.body, {childList: true, subtree: true});

        document.addEventListener("click", (event) => {
            if (event.target.matches(".clear-search")) {
                const searchInput = document.querySelector(".resources-search");
                if (searchInput) {
                    searchInput.value = "";
                    toggleClearSearchActive();
                    sendAjaxRequest(collectFilterData());
                }
            }
        });

        function reloadFieldsets(data) {
            const filtersWrapper = ajaxContainer.querySelector(".filters .options-list");

            const formData = new FormData();
            formData.append("action", "reload_resources");
            formData.append("security", nonce);
            formData.append("config", JSON.stringify(resourcesConfig));

            Object.keys(data).forEach((key) => {
                if (Array.isArray(data[key])) {
                    data[key].forEach((value) => formData.append(`${key}[]`, value));
                } else {
                    formData.append(key, data[key]);
                }
            });

            filtersWrapper.classList.add("loading");
            fetch(ajaxUrl, {
                method: "POST",
                body: formData,
            })
                .then((response) => response.json())
                .then((response) => {
                    filtersWrapper.classList.remove("loading");
                    if (response.success) {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(response.data.html, "text/html");
                        const newFieldsets = doc.querySelectorAll("fieldset");
                        const currentFieldsets = document.querySelectorAll(".options-list fieldset");

                        if (currentFieldsets.length > 0) {
                            const placeholder = document.createElement("div");
                            placeholder.style.display = "none";
                            currentFieldsets[currentFieldsets.length - 1].after(placeholder);
                            currentFieldsets.forEach((fieldset) => fieldset.remove());
                            newFieldsets.forEach((newFieldset) => placeholder.insertAdjacentElement("beforebegin", newFieldset));
                            placeholder.remove();
                            updateFilterOptions();
                            updatePagination();
                        }
                    } else {
                        console.error("Failed to load resources:", response.data.message);
                    }
                })
                .catch((error) => {
                    console.error("Error fetching resources:", error);
                    popupConfirm("Error", "An unknown error has occurred. Please reload the page and try again.", "If the error persists, please contact customer service.", "Close", "").then(() => {
                    });
                    ajaxContainer.classList.remove("loading");
                });
        }

        document.addEventListener("change", (event) => {
            if (isMobile.matches && event.target.closest("fieldset.master") && event.target.matches('input[type="checkbox"]')) {
                reloadFieldsets(collectFilterData());
            }
        });

        document.addEventListener("click", (event) => {
            if (event.target.matches(".alphabet-filtering button") && !event.target.disabled) {
                event.preventDefault();

                document.querySelectorAll(".alphabet-filtering button").forEach((button) => button.classList.remove("active"));

                event.target.classList.add("active");

                sendAjaxRequest(collectFilterData());
                updateFilterOptions();
            }
        });
    }
});
